import React, { useEffect } from 'react'
import { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { format } from 'date-fns';
import './CalendarStyles.css'
import { base_url } from '../../utils/AxiosConfig';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Oval } from 'react-loader-spinner';
import { TextField } from '@mui/material';


const ValuePiece = Date | null;

const Value = ValuePiece | [ValuePiece, ValuePiece];

const HolidaySettingPopup = ({ popUpData, onDataUpdate, allBranchData, allBranchFetchLoader }) => {

  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
  }

  const [value, onChange] = useState();
  const [calenderData, SetcalenderData] = useState();
  const valueString = value?.toString()
  const dateArray = valueString?.split(' ');
  const [selectedDates, setSelectedDates] = useState(null);

  const [selectedDate, setSelectedDate] = useState(null);
  const [formatDate, setFormatDate] = useState([])
  const [leaveType, setLeaveType] = useState(null)

  const [leaveName, setLeaveName] = useState('')

  const [branch, setBranch] = useState(null)

  const [weekDay, setWeekday] = useState(null)

  const [activeTab, setActiveTab] = useState("profile");

  const [deptNoArray, setDeptNoArray] = useState([
    'HO', 'ABC', 'XYZ'
  ])

  const [branchSelectionLoader, setBranchSelectionLoader] = useState(false)

  // State to hold selected deptno items
  const [selectedDepts, setSelectedDepts] = useState([]);

  const [branchHolidayList, setBranchHolidayList] = useState([])


  const [checkboxState, setCheckboxState] = useState({
    sun: false,
    sat: false,
    fri: false,
    chk1: false,
    chk2: false,
    chk3: false,
    cmbabsent: "",
    cmblate: '',
    cmbalert: ''
  });

  // Handle checkbox change
  const handleDeptCheckboxChange = (deptno) => {
    if (deptno === "All") {
      if (selectedDepts.length === allBranchData.length) {
        // If "All" is unchecked, deselect all
        setSelectedDepts([]);
      } else {
        // If "All" is checked, select all
        setSelectedDepts(allBranchData.map((item) => item.deptno.trim()));
      }
    } else {
      // Individual checkbox change
      setSelectedDepts((prevSelected) =>
        prevSelected.includes(deptno)
          ? prevSelected.filter((item) => item !== deptno) // Uncheck
          : [...prevSelected, deptno] // Check
      );
    }
  };

  // Function to handle tab switching
  const handleTabSwitch = (tabId) => {
    setActiveTab(tabId);
  };

  // Handler to toggle checkbox state
  const handleCheckboxChange = (name) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  // Handler for input changes (for cmblate and cmbalert)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handler for weekday selection to update cmbabsent
  const handleWeekdayChange = (value) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      cmbabsent: value, // Set cmbabsent to the selected day
    }));
  };

  const handleBranchChange = (e) => {
    const selectedBranch = e.target.value;
    setBranch(selectedBranch);

    // Adjust request body based on the selected branch
    if (selectedBranch === "1") { // "All" is selected
      // Add logic to handle all branches
      // Here, I assume you want to create multiple entries for different branches
      const branches = [
        { ...checkboxState, deptno: "HO" }, // Adjust this as necessary for each branch
        { ...checkboxState, deptno: "ABC" }
      ];
      setCheckboxState(branches);
    } else {
      setCheckboxState((prev) => ({
        ...prev,
        deptno: selectedBranch // Assuming you have a mapping of branch values to deptno
      }));
    }
  };

  // Function to map true/false to "Checked"/"Unchecked"
  const mapCheckboxState = (state) => ({
    ...state,
    sun: state.sun ? "Checked" : "Unchecked",
    sat: state.sat ? "Checked" : "Unchecked",
    fri: state.fri ? "Checked" : "Unchecked",
    chk1: state.chk1 ? "Checked" : "Unchecked",
    chk2: state.chk2 ? "Checked" : "Unchecked",
    chk3: state.chk3 ? "Checked" : "Unchecked"
  });

  const handleBranchSubmit = async () => {

    const CmpCode = companyCode;

    const mappedCheckboxState = mapCheckboxState(checkboxState);


    let requestBody = branch === "1"
      ? allBranchData.map((dept) => ({ CmpCode, ...mappedCheckboxState, deptno: dept.deptno.trim() }))
      : [{ CmpCode, ...mappedCheckboxState, deptno: branch.trim() || "" }];

    // const requestBody = (selectedDepts.length === allBranchData.length)
    //   ? allBranchData.map((dept) => ({ CmpCode, ...mappedCheckboxState, deptno: dept.deptno.trim() }))
    //   : selectedDepts.map((dept) => ({ CmpCode, ...mappedCheckboxState, deptno: dept }))
    // : [{ CmpCode, ...mappedCheckboxState, deptno: branch.trim() || "" }];




    requestBody = [{
      ...requestBody[0],
      COMPANYLABOURNO: branchHolidayList[0].COMPANYLABOURNO ? branchHolidayList[0].COMPANYLABOURNO : "",
      BANKROUTINGCODE: branchHolidayList[0].BANKROUTINGCODE ? branchHolidayList[0].BANKROUTINGCODE : "",
      COMPANYIBAN: branchHolidayList[0].COMPANYIBAN ? branchHolidayList[0].COMPANYIBAN : "",
      ESTABLISHMENT: branchHolidayList[0].ESTABLISHMENT ? branchHolidayList[0].ESTABLISHMENT : ""
    }
    ]

    console.log('requestBody branchlist', requestBody, branchHolidayList)

    const endpoint = `${base_url}/api/CRMHRHolidayMain`;

    const postData = JSON.stringify(requestBody)

    console.log('postData', postData)

    console.log('endpoint', endpoint)

    try {
      const response = await axios.post(endpoint, postData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('Response:', response.data);

      if (response.status === 200) {
        toast.success('Holiday Submitted')

        setCheckboxState({
          sun: false,
          sat: false,
          fri: false,
          chk1: false,
          chk2: false,
          chk3: false,
          cmbabsent: "",
          cmblate: '',
          cmbalert: ''
        })

        setBranch('0')

        setSelectedDepts([])
      }
    } catch (error) {
      console.error('Error posting data:', error);

      toast.error('Some Error occured')

      setCheckboxState({
        sun: false,
        sat: false,
        fri: false,
        chk1: false,
        chk2: false,
        chk3: false,
        cmbabsent: "",
        cmblate: '',
        cmbalert: ''
      })

      setBranch('0')

      setSelectedDepts([])
    }
  };

  const handlePublicHolidaySubmit = async () => {

    const endpoint = `${base_url}/api/CRMHRHolidaySub`;

    // Hardcoded values and dynamic values
    const CmpCode = companyCode;
    const hdate = formatDate; // Assuming formatDate is your formatted date string
    const hname = leaveName;

    // Set up the request body based on branch selection
    let requestBody = branch === "1"
      ? allBranchData.map((dept) => ({ CmpCode, hdate, hname, deptno: dept.deptno.trim() }))
      : [{ CmpCode, hdate, hname, deptno: branch.trim() || "" }];


    // Set up the request body based on branch selection
    // const requestBody = (selectedDepts.length === allBranchData.length)
    //   ? allBranchData.map((dept) => ({ CmpCode, hdate, hname, deptno: dept.deptno.trim() }))
    //   : selectedDepts.map((dept) => ({ CmpCode, hdate, hname, deptno: dept }))
    // : [{ CmpCode, hdate, hname, deptno: branch.trim() || "HO" }];

    const postData = JSON.stringify(requestBody)

    console.log('postData', postData)

    console.log('endpoint', endpoint)

    // Send POST request with axios
    try {
      const response = await axios.post(endpoint, requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log('Success:', response.data);

      if (response.status === 200) {
        toast.success('Holiday Submitted')

        setLeaveName('')
        setFormatDate([])

        setBranch('0')

        setSelectedDate(null)

        setSelectedDepts([])
      }
    } catch (error) {
      console.error('Error:', error);

      toast.error('Some Erro Occured')

      setLeaveName('')
      setFormatDate([])

      setBranch('0')

      setSelectedDate(null)

      setSelectedDepts([])
    }

  }


  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formatted = format(date, 'dd-MMM-yyyy'); 
    setFormatDate(formatted);
  };

  const removeDateAndLeave = () => {
    setFormatDate([])
    setLeaveType(null)
    setSelectedDates(null)
  }

  const fetchBranchHolidayList = async () => {
    setBranchSelectionLoader(true)
    try {
      const response = await axios.get(`${base_url}/api/CRMHRHolidayList/${companyCode}/HOLIDAYMAIN/${branch}`)

      if (response.status === 200) {
        console.log("res of Holiday main ", response.data)
        setBranchHolidayList(response.data)
        setBranchSelectionLoader(false)
      }
    } catch (error) {
      console.log('fetchBranchHolidayListError', error)
      setBranchSelectionLoader(false)
    }
  }

  useEffect(() => {
    if (branch && branch !== '1') {
      fetchBranchHolidayList()
    } else {
      setCheckboxState({
        sun: false,
        sat: false,
        fri: false,
        chk1: false,
        chk2: false,
        chk3: false,
        cmbabsent: "",
        cmblate: '',
        cmbalert: ''
      })
    }
  }, [branch])

  useEffect(() => {
    if (branchHolidayList && branchHolidayList.length > 0) {
      const apiData = branchHolidayList[branchHolidayList.length - 1];

      setCheckboxState({
        sun: apiData.sun === "Checked",
        sat: apiData.sat === "Checked",
        fri: apiData.fri === "Checked",
        chk1: apiData.chk1 === "Checked",
        chk2: apiData.chk2 === "Checked",
        chk3: apiData.chk3 === "Checked",
        cmbabsent: apiData.cmbabsent || "",
        cmblate: apiData.cmblate || "",
        cmbalert: apiData.cmbalert || ""
      });
    } else {
      setCheckboxState({
        sun: false,
        sat: false,
        fri: false,
        chk1: false,
        chk2: false,
        chk3: false,
        cmbabsent: "",
        cmblate: '',
        cmbalert: ''
      })
    }
  }, [branchHolidayList]);

  useEffect(() => {
    if (formatDate.length > 0 && leaveType !== null) {
      onDataUpdate(formatDate, leaveType, popUpData?.EmpId);
    }
  }, [formatDate, leaveType, popUpData])

  // console.log(selectedDates,'selectedDates')
  // console.log(formatDate,'formatDate')
  // console.log(leaveType,'leaveType')

  // console.log(popUpData,'popUpData')

  // console.log('checkboxState', checkboxState)

  // console.log('branchHolidayList',branchHolidayList)

  console.log('branch', branch)

  const handleInputWPS = (e, fieldName) => {

    console.log("branchHolidayList ", branchHolidayList)
    let updatedArray =  {...branchHolidayList[0], [fieldName]: e.target.value} 

    console.log("branchHolidayList updatedArray ", updatedArray)

    setBranchHolidayList([updatedArray])
  }


  return (
    <div style={{
      backgroundColor: 'white',
      marginTop: '16px', padding: '16px',
      borderRadius:'16px',
    }}>

      <div style={{
        // backgroundColor: 'white',
        margin: '16px 0px'
      }}>
        <h1 class="modal-title  text-secondary fs-small" id="staticBackdropLabel">Holiday Setting</h1>
      </div>

      <div className="container-fluid">
        <div className="row">

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Branch Based Holiday</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Public Holiday</a>
            </li>
          </ul>

          <div class="form-check d-flex align-items-center gap-2 mt-2 mb-2">
            <label for="exampleInputEmail1" class="fs-small text-secondary">Branch</label>

            {
              allBranchFetchLoader ?
                <Oval
                  visible={true}
                  height="30"
                  width="30"
                  color="#4fa94d"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                /> :

                <select class="form-select" style={{ width: '150px' }} aria-label="Default select example" value={branch} onChange={(e) => setBranch(e.target.value)}>
                  <option selected value='0'>Select</option>
                  {/* <option value="1">All</option> */}

                  {
                    allBranchData.map((item, index) => (
                      <option value={item.deptno}>{item.deptno}</option>
                    ))
                  }
                </select>
            }

            {
              branchSelectionLoader &&
              <Oval
                visible={true}
                height="30"
                width="30"
                color="#4fa94d"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            }

            <span style={{ fontSize: "14px", marginLeft: "4px", color: "#767676" }}>Please select a branch to make changes</span>
          </div>

          <div className="col-md-12 tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

            <div className='row align-items-center'>

              {/* <div className="col-md-2" style={{
                maxHeight: '250px',
                overflowY: 'scroll'
              }}>
              
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value="All"
                    id="dept-all"
                    checked={selectedDepts.length === allBranchData.length}
                    onChange={() => handleDeptCheckboxChange("All")}
                  />
                  <label className="form-check-label popLabels" htmlFor="dept-all">
                    All
                  </label>
                </div>

               
                {allBranchData.map((item, index) => (
                  <div className="form-check" key={index}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={item.deptno.trim()}
                      id={`dept-${index}`}
                      checked={selectedDepts.includes(item.deptno.trim())}
                      onChange={() => handleDeptCheckboxChange(item.deptno.trim())}
                    />
                    <label className="form-check-label popLabels" htmlFor={`dept-${index}`}>
                      {item.deptno.trim()}
                    </label>
                  </div>
                ))}
              </div> */}

              <div className='col-md-6'>
                <Calendar
                  onChange={handleDateChange}
                  value={selectedDate}
                  //  selectRange 
                  className="mt-3" />
              </div>

              <div className='col-md-6'>
                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Selected Date</label>
                  <input type="text" class="form-control" value={formatDate} disabled />

                </div>

                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Leave Name</label>
                  <input type="text" class="form-control" value={leaveName} onChange={(e) => setLeaveName(e.target.value)} />
                </div>
              </div>

            </div>


            <div class="modal-footer" style={{ gap: "24px" }}>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="applyAll"
                  name="1"
                  checked={branch === '1'}
                  onChange={() => setBranch(branch === '1' ? '' : '1')}
                />
                <label class="form-check-label popLabels" for="applyAll">Apply to all branches</label>
              </div>

              {branch && branch !== '0' && (
                <button type="button" className="btn dash-btn" onClick={() => handlePublicHolidaySubmit()}>
                  Add
                </button>
              )}


            </div>
          </div>

          <div className="tab-pane fade show active mt-3" id="home" role="tabpanel" aria-labelledby="home-tab">

            <div style={{ display: "flex", justifyContent: "space-between" }}>


              <div >
                <div class="mb-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox" id="sundayCheck"
                      name="sun"
                      checked={checkboxState.sun}
                      onChange={() => handleCheckboxChange("sun")} disabled={branch === '0' || !branch}
                    />
                    <label class="form-check-label popLabels" for="sundayCheck">All Sundays</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="sat"
                      checked={checkboxState.sat}
                      onChange={() => handleCheckboxChange("sat")} disabled={branch === '0' || !branch} id="saturdayCheck" />
                    <label class="form-check-label popLabels" for="saturdayCheck">All Saturdays</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="fri"
                      checked={checkboxState.fri}
                      onChange={() => handleCheckboxChange("fri")} disabled={branch === '0' || !branch} id="fridayCheck" />
                    <label class="form-check-label popLabels" for="fridayCheck">All Fridays</label>
                  </div>
                  <div class="form-check d-flex align-items-center gap-2">
                    <input class="form-check-input" type="checkbox" name="chk1"
                      checked={checkboxState.chk1}
                      onChange={() => handleCheckboxChange("chk1")} disabled={branch === '0' || !branch} id="AbsentieCheck" />
                    <label class="form-check-label popLabels" for="AbsentieCheck">
                      2-day non-pay for Absentees on
                    </label>

                    <div style={{ width: '125px' }}>
                      <select class="form-select" aria-label="Default select example" disabled={branch === '0' || !branch} value={checkboxState.cmbabsent} onChange={(e) => handleWeekdayChange(e.target.value)}>
                        <option selected value=''>---</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                      </select>
                    </div>

                  </div>
                  <div class="form-check d-flex align-items-center gap-2">
                    <input class="form-check-input" type="checkbox" name="chk2"
                      checked={checkboxState.chk2}
                      onChange={() => handleCheckboxChange("chk2")} disabled={branch === '0' || !branch} id="LatePunchCheck" />
                    <label class="form-check-label popLabels" for="LatePunchCheck">Late punch Extension (Minutes)</label>
                    <div style={{ width: '125px' }}>
                      <input type="text" className='form-control' name="cmblate"
                        value={checkboxState.cmblate}
                        disabled={branch === '0' || !branch}
                        onChange={handleInputChange} />
                    </div>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="chk3"
                      checked={checkboxState.chk3}
                      onChange={() => handleCheckboxChange("chk3")} disabled={branch === '0' || !branch} id="3DayLateCheck" />
                    <label class="form-check-label popLabels" for="3DayLateCheck">3-days continous late punch = 1 day non-pay</label>
                  </div>

                  <div class="form-check d-flex align-items-center gap-2">
                    <label class="form-check-label popLabels" disabled={branch === '0' || !branch}>Alert Notification Due Days</label>
                    <div style={{ width: '125px' }}>
                      <input type="text" className='form-control' name="cmbalert"
                        value={checkboxState.cmbalert}
                        disabled={branch === '0' || !branch}
                        onChange={handleInputChange} />
                    </div>
                  </div>

                </div>
              </div>

              <div style={{ width: "60%" }}>
                <h6>WPS Settings</h6>
                <div style={{ display: "flex", flexDirection: "column", width: "70%" }}>
                  <TextField style={{ marginTop: "20px" }} id="standard-basic" label="Company Labour Number" value={branchHolidayList[0]?.COMPANYLABOURNO ? branchHolidayList[0]?.COMPANYLABOURNO : ""} variant="standard" onChange={(e) => handleInputWPS(e, "COMPANYLABOURNO")} />
                  <TextField style={{ marginTop: "10px" }} id="standard-basic" label="Bank Routing Code" value={branchHolidayList[0]?.BANKROUTINGCODE ? branchHolidayList[0]?.BANKROUTINGCODE : ""} variant="standard" onChange={(e) => handleInputWPS(e, "BANKROUTINGCODE")} />
                  <TextField style={{ marginTop: "10px" }} id="standard-basic" label="Company IBAN" value={branchHolidayList[0]?.COMPANYIBAN ? branchHolidayList[0]?.COMPANYIBAN : ""} variant="standard" onChange={(e) => handleInputWPS(e, "COMPANYIBAN")} />
                  <TextField style={{ marginTop: "10px" }} id="standard-basic" label="Establishment" variant="standard" value={branchHolidayList[0]?.ESTABLISHMENT ? branchHolidayList[0]?.ESTABLISHMENT : ""} onChange={(e) => handleInputWPS(e, "ESTABLISHMENT")} />

                </div>
              </div>

            </div>


            <div class="modal-footer" style={{ gap: "24px" }}>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="applyAll"
                  name="1"
                  checked={branch === '1'}
                  onChange={() => setBranch(branch === '1' ? '' : '1')}
                />
                <label class="form-check-label popLabels" for="applyAll">Apply to all branches</label>
              </div>

              {
                branch && branch !== '0' &&
                <button type="button" class="btn dash-btn" onClick={() => handleBranchSubmit()}>Add</button>
              }

            </div>

          </div>

        </div>
      </div>



    </div >
  )
}

export default HolidaySettingPopup
